import React, { useState } from "react";
import { Link } from "react-router-dom";

import { useTranslation } from "react-i18next";
import LanguageSelector from './LanguageSelector';

function MainMenu() {
    const [menuOpen, setMenuOpen] = useState(false);

    const closeMenu = () => {
        setMenuOpen(false);
    };

    const { t } = useTranslation();
    return (
        <div style={{ width: "100%" }}>
            <div className="row menubar align-items-center">

                {/* LOGO */}
                <div className="col-md-4 col-8">
                    <div style={{ paddingLeft: "10%", paddingTop: "10px", paddingBottom: "10px" }}>
                        <div style={{ display: 'flex' }}>
                            <div className="logo-image" >
                                <img src="./images/murugan-2.png" style={{ width: "60%" }} alt="logo" />
                            </div>
                            <div style={{ float: 'left',display:'flex',alignItems:'center',justifyContent:'center' }}>
                                <span className="templename" style={{color:'white'}}>
                                    {t("temple_name")}
                                </span>
                                {/* <span className="templename" style={{color:'white'}}>
                                    ശ്രീ പെരളശ്ശേരി ക്ഷേത്രം
                                </span> */}
                            </div>

                        </div>
                    </div>
                </div>

                {/* HAMBURGER BUTTON (Mobile only) */}
                <div className="col-4 d-md-none text-end pe-4">
                    <button
                        className="btn btn-outline-warning humberger"
                        onClick={() => setMenuOpen(!menuOpen)}
                    >
                        ☰
                    </button>
                </div>

                {/* MENU ITEMS */}
                {/* MENU ITEMS */}
                <div className={`col-md-8 menu-wrapper ${menuOpen ? "show" : ""}`}>
                    <div className="container containeritems">

                        <div className="boxes">
                            <Link to="/" className="menuitems" onClick={closeMenu}>
                            {t("home")}
                            </Link>
                        </div>

                        <div className="boxes">
                            <Link to="/History" className="menuitems" onClick={closeMenu}>
                            {t("history")}
                            </Link>
                        </div>

                        <div className="boxes">
                            <a
                                href="https://booking.peralasserytemple.in"
                                className="menuitems"
                                onClick={closeMenu}
                            >
                                 {t("onlinebooking")}
                            </a>
                        </div>

                        <div className="boxes">
                            <Link to="/Timing" className="menuitems" onClick={closeMenu}>
                            {t("darsantime")}
                            </Link>
                        </div>

                        <div className="boxes">
                            <Link to="/Administration" className="menuitems" onClick={closeMenu}>
                            {t("administration")}
                            </Link>
                        </div>

                        <div className="boxes">
                            <Link to="/Gallery" className="menuitems" onClick={closeMenu}>
                            {t("gallery")}
                            </Link>
                        </div>

                        <div className="boxes">
                            <Link to="/Contact" className="menuitems" onClick={closeMenu}>
                            {t("contact")}
                            </Link>
                        </div>
                        <div className="boxes" >
                            <LanguageSelector  />
                        </div>

                    </div>
                </div>
</div>
            <div style={{width:'100px',height:'100px',position:'fixed',bottom:'0',right:'0',marginRight:'10px',marginBottom:'10px'}}>
               <a href="https://booking.peralasserytemple.in/"> <img src="./images/online-booking.png" alt="Online Booking" style={{width:'100%',border:'4px solid white',borderRadius:'10px'}} /></a>
            </div>
        </div>
    );
}

export default MainMenu;
